import { createSlice, current } from '@reduxjs/toolkit';

const AppSlice = createSlice({
    name: 'app',
    initialState: {
        isFullScreen: false,
        currentSymbol: '',
        currentCompanyName: '',
        currentSymbolImage: '',
        marketCurrentPrice: 0,
        marketData: null
    },
    reducers: {
        toggleFullScreen: (state) => {
            state.isFullScreen = !state.isFullScreen;
        },
        setMarketCurrentPrice: (state, action) => {
            state.marketCurrentPrice = action.payload;
        },
        setCurrentSymbol: (state, action) => {
            state.currentSymbol = action.payload.symbol;
            state.currentCompanyName = action.payload.companyName;
            state.currentSymbolImage = action.payload.symbolImage;
        },
        setMarketData: (state, action) => {
            state.marketData = action.payload;
        }
    }
});

export const { toggleFullScreen, setCurrentSymbol, setMarketCurrentPrice, setMarketData } = AppSlice.actions;
export default AppSlice.reducer;
